import {
  DisplayElement,
  filterDisplayElementHideCondition,
} from '@urbanx/agx-ui-components'
import { AppFeatures } from '@urbanx/agx.agencies.client'
import { CampaignDetailModel, FormPage } from '@urbanx/agx.campaigns.client'
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import clsx from 'clsx'
import { useMemo } from 'react'
import slugify from 'slugify'
import { FormValue, FormValueType } from 'types/formConfig'
import elementRenderer from 'utils/elementRenderer'

interface PanelElementRendererProps {
  panel: FormPage
  formValues: FormValue
  getAuthToken: () => Promise<string>
  onChange: (change: {
    id: string
    value: FormValueType[keyof FormValueType]
  }) => void
  campaign: CampaignDetailModel
  validate: boolean
  featureToggles?: AppFeatures
  featureTogglesLoading: boolean
}

const PanelElementRenderer = ({
  panel,
  formValues,
  getAuthToken,
  onChange,
  campaign,
  validate,
  featureToggles,
  featureTogglesLoading,
}: PanelElementRendererProps) => {
  const slugifiedPanelName = useMemo(() => {
    return slugify(panel.name ?? '')
  }, [panel?.name])

  const classes = useMemo(() => {
    return clsx(!panel?.hideFormPageName && 'panelContainer')
  }, [panel?.hideFormPageName])

  const elements = useMemo(() => {
    return filterDisplayElementHideCondition(
      (panel?.elements ?? []) as unknown as DisplayElement[],
      formValues
    )
  }, [panel?.elements, formValues])

  return (
    <AgxSpacer
      direction="vertical"
      gap="lg"
      key={slugifiedPanelName}
      className={classes}
      id={slugifiedPanelName}
    >
      {!panel.hideFormPageName && (
        <div className="panelTitleContainer">
          <AgxTypography
            id={`${slugifiedPanelName}-title`}
            type="heading"
            size="medium"
            color="var(--text-primary)"
          >
            {panel.name}
          </AgxTypography>
        </div>
      )}
      {panel.elements &&
        elementRenderer({
          elements: elements,
          onChange,
          campaign,
          getAuthToken,
          formValues,
          validate,
          featureToggles,
          featureTogglesLoading,
        })}
    </AgxSpacer>
  )
}

export default PanelElementRenderer
